import { combineReducers } from 'redux'

import { reducer as upgradeNotetakerSpotlight } from './upgrade_notetaker_spotlight_slice'

export const reducer = combineReducers({
  upgradeNotetakerSpotlight
})
